import { PencilSimpleLine } from '@phosphor-icons/react';
import { useTranslation } from 'react-i18next';

import { IPartFinderProductType } from 'companySettings/types';
import { Button } from 'core/components';
import { useAgGridClientTableContext } from 'core/states';
import { Variant } from 'theme/enums';

import { UpsertPartFinderProductTypeButton } from '../UpsertPartFinderProductType';

// The editor edits one product type, so the button needs exactly one selected row.
export const EditPartFinderProductTypeButton = () => {
  const { t } = useTranslation();

  const { selectedRows } = useAgGridClientTableContext();

  const productType =
    1 === selectedRows?.length ? (selectedRows[0] as IPartFinderProductType) : undefined;

  return (
    <UpsertPartFinderProductTypeButton
      productType={productType}
      buttonElement={
        <Button
          text={t('buttonLabelEdit')}
          variant={Variant.OUTLINED}
          startDecorator={<PencilSimpleLine />}
          disabled={!productType}
        />
      }
    />
  );
};
